module.exports = __webpack_public_path__ + "static/media/2022_composite.9536f87e.jpg";